// Unified Theme System
// Sistema unificado que combina todos los temas de clientes

import { Theme, ThemeMode, ThemeBrand } from '../types';
import { coraLightTheme, coraDarkTheme, coraThemes } from './cora';
import { roisLightTheme, roisDarkTheme, roisThemes } from './rois';

// ========================================
// FUNCIÓN UNIFICADA DE OBTENCIÓN DE TEMAS
// ========================================

export const getTheme = (brand: ThemeBrand, mode: ThemeMode): Theme => {
  switch (brand) {
    case 'cora':
      return mode === 'dark' ? coraDarkTheme : coraLightTheme;
    case 'rois':
      return mode === 'dark' ? roisDarkTheme : roisLightTheme;
    case 'custom':
      // Para futuros clientes personalizados, usar CORA como fallback
      return mode === 'dark' ? coraDarkTheme : coraLightTheme;
    default:
      return mode === 'dark' ? coraDarkTheme : coraLightTheme;
  }
};

// ========================================
// EXPORTS INDIVIDUALES
// ========================================

// Temas CORA
export { coraLightTheme, coraDarkTheme, coraThemes } from './cora';

// Temas ROIS
export { roisLightTheme, roisDarkTheme, roisThemes } from './rois';

// ========================================
// OBJETO UNIFICADO DE TODOS LOS TEMAS
// ========================================

export const allThemes = {
  cora: coraThemes,
  rois: roisThemes,
} as const;

// ========================================
// COMPATIBILIDAD HACIA ATRÁS
// ========================================

// Tema por defecto (CORA claro)
export const defaultTheme = coraLightTheme;

// Exports para compatibilidad hacia atrás
export const lightTheme = coraLightTheme;
export const darkTheme = coraDarkTheme;

// Alias del objeto unificado
export const themes = allThemes;

export type AvailableThemes = keyof typeof allThemes;
export type AvailableThemeModes = keyof typeof coraThemes;
